import { Button, HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { RESET_STATE } from 'components/Map/hooks/useBoundaryReset/constants';
import CheckmarkIcon from 'components/icons/CheckmarkIcon';
import BodyText from 'components/text/BodyText';

import useTranslation from './hooks/useTranslation';

import { ACTION_BUTTON_TEST_ID, CLOSE_BUTTON_TEST_ID, TEST_ID } from './constants';
import type { Props, ResetTypeMap } from './types';

import styles from './styles.module.scss';

const MapControlResetPopup = ({ className = '', resetState, testId = TEST_ID }: Props) => {
    const {
        ABANDON_AND_CREATE,
        ABANDON_BOUNDARY,
        BACK,
        DELETE_AND_START_OVER,
        LEAVE_AND_DISCARD,
        LEAVE_BEFORE_SAVE,
        SAVE,
        START_OVER
    } = useTranslation();

    const RESET_TYPE_MAP: Record<RESET_STATE, ResetTypeMap> = {
        [RESET_STATE.DELETE_AND_START_OVER]: {
            actionButtonText: DELETE_AND_START_OVER,
            bodyText: START_OVER,
            closeButtonText: BACK
        },
        [RESET_STATE.LEAVE_AND_DISCARD]: {
            actionButtonText: LEAVE_AND_DISCARD,
            bodyText: LEAVE_BEFORE_SAVE,
            closeButtonText: (
                <>
                    <CheckmarkIcon className={styles.checkmarkIcon} />

                    {SAVE}
                </>
            )
        },
        [RESET_STATE.ABANDON_AND_CREATE]: {
            actionButtonText: ABANDON_AND_CREATE,
            bodyText: ABANDON_BOUNDARY,
            closeButtonText: BACK
        }
    };

    if (!resetState) {
        return null;
    }

    const { onAction, onClose, resetType } = resetState;
    const { actionButtonText, bodyText, closeButtonText } = RESET_TYPE_MAP[resetType];

    return (
        <Wrapper className={`${styles.modal} ${className}`} onClick={onClose} testId={testId}>
            <div onClick={event => event.stopPropagation()}>
                <VerticalContainer className={`${styles.verticalContainer}`}>
                    <BodyText className={styles.bodyText}>{bodyText}</BodyText>

                    <HorizontalContainer>
                        <Button
                            className={`${styles.closeButton} ${styles.buttonText}`}
                            onClick={onClose}
                            testId={CLOSE_BUTTON_TEST_ID}>
                            {closeButtonText}
                        </Button>

                        <Button
                            className={`${styles.actionButton} ${styles.buttonText}`}
                            onClick={onAction}
                            testId={ACTION_BUTTON_TEST_ID}>
                            {actionButtonText}
                        </Button>
                    </HorizontalContainer>
                </VerticalContainer>
            </div>
        </Wrapper>
    );
};

export default MapControlResetPopup;
